var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIosDownwardOutline1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-ios-downward-outline",
    d: "M9.984,0a1.349,1.349,0,0,0-.913.361L.515,8.218A1.684,1.684,0,0,0,.33,10.433a1.34,1.34,0,0,0,2.011.2L9.984,3.6l7.644,6.785a1.337,1.337,0,0,0,1.05.343,1.4,1.4,0,0,0,.961-.578,1.675,1.675,0,0,0,.355-1.195,1.616,1.616,0,0,0-.554-1.1L10.883.271A1.329,1.329,0,0,0,9.984,0Z",
    transform: "translate(11) rotate(90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIosDownwardOutline1);
export default __webpack_public_path__ + "static/media/arrow-ios-downward-outline (1).1be7d3ffd32925ed9b91e213112a332b.svg";
export { ForwardRef as ReactComponent };